import { Transformation } from 'app/model/dataflow/transformation';
import { AggregateTransformation } from 'app/model/dataflow/aggregatetransformation';
import { Constants } from 'app/shared/shared-constants';
import { DataFlowSchemaAdapterUtils } from '../../dataflow-schema-adapter-utils';
import { AggregatePlainObject } from 'worker/app-workers/shared/plainObjects/aggregate.plainObject';
import { SchemaModifierBaseConvertor } from './schemaModifierBase.convertor';
import { IResourceContext } from 'shell-models-lib';

export class AggregateConvertor extends SchemaModifierBaseConvertor {
    private get aggTransform(): AggregateTransformation {
        return this.transformation as AggregateTransformation;
    }

    private get aggObject(): AggregatePlainObject {
        return this.transformObject as AggregatePlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);

        this.aggObject.groupByColumns.forEach((column) => {
            const groupByColumn = this.aggTransform.addGroupByColumn();
            const unescapedColumnName = Constants.dataFlowEscapedNameValidation.test(column.name)
                ? DataFlowSchemaAdapterUtils.removeWrappingCharacters(column.name)
                : column.name;
            groupByColumn.column.name = column.expression
                ? unescapedColumnName
                : DataFlowSchemaAdapterUtils.extractColumnName(unescapedColumnName);
            groupByColumn.dataFlowExpression.expression = column.expression || column.name;
        });
        super.postConvert();
        return this.transformation;
    }
}
